import { useGlobalContext } from '@honeycomb/data';
import { IFrameField, TextField, usePrevious } from '@honeycomb/ui-core';
import React, { useEffect } from 'react';
import { initTokenisingField } from './services/tokenisingField';
export var TokenisingFieldType;
(function (TokenisingFieldType) {
    TokenisingFieldType[TokenisingFieldType["CardNumber"] = 0] = "CardNumber";
    TokenisingFieldType[TokenisingFieldType["CVV"] = 1] = "CVV";
    TokenisingFieldType[TokenisingFieldType["ENDBCardNumber"] = 2] = "ENDBCardNumber";
    TokenisingFieldType[TokenisingFieldType["EnbdCVV"] = 3] = "EnbdCVV";
})(TokenisingFieldType || (TokenisingFieldType = {}));
export function TokenisingField(props) {
    const { placeholder, fieldType, name, autocomplete, validateAs, refresh, clientId, validationStatus = 'none', focused = false, } = props;
    const iFrameRef = React.useRef(null);
    const hiddenInputRef = React.useRef(null);
    const fieldStyle = React.useRef(null);
    const previousRefresh = usePrevious(refresh);
    const { configSettings: { PCIFrameUrl }, } = useGlobalContext();
    useEffect(() => {
        const style = hiddenInputRef.current && window.getComputedStyle(hiddenInputRef.current);
        fieldStyle.current = {
            padding: (style === null || style === void 0 ? void 0 : style.getPropertyValue('padding')) || '',
            lineHeight: (style === null || style === void 0 ? void 0 : style.getPropertyValue('line-height')) || '',
            height: (style === null || style === void 0 ? void 0 : style.getPropertyValue('height')) || '',
            fontFamily: (style === null || style === void 0 ? void 0 : style.getPropertyValue('font-family')) || '',
            fontWeight: (style === null || style === void 0 ? void 0 : style.getPropertyValue('font-weight')) || '',
            color: (style === null || style === void 0 ? void 0 : style.getPropertyValue('color')) || '',
            appearance: (style === null || style === void 0 ? void 0 : style.getPropertyValue('-webkit-appearance')) || '',
        };
    }, [hiddenInputRef, fieldStyle]);
    const initialiseField = () => {
        if (iFrameRef !== null) {
            initTokenisingField({
                placeholder,
                fieldType,
                name,
                autocomplete,
                validateAs,
                iframeElement: iFrameRef.current,
                style: fieldStyle.current,
                clientId,
                tokenExpiryMessage: 'resourceStrings.TOKEN_EXPIRY_MESSAGE',
                pciFrameUrl: PCIFrameUrl,
            });
        }
    };
    // BD: This looks like it should be in a useEffect.
    if (refresh !== previousRefresh) {
        initialiseField();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(IFrameField, { iFrameRef: iFrameRef, title: `pciFrame_${validateAs}`, src: PCIFrameUrl, validationStatus: validationStatus, onLoad: () => initialiseField(), "data-cs-mask": "", FieldRootProps: { zIndex: 1 }, focused: focused, fullWidth: true }),
        React.createElement(TextField, { inputRef: hiddenInputRef, FieldRootProps: { display: 'none' }, "data-fake": true })));
}
